import { Box, Button, Typography } from '@mui/material';
import type { HydratedMarketplaceRateTableProps } from '@repo/supergraph-schemas/structuredContent/hydration/MarketplaceRateTable/types';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { AdvertiserWrapper } from './AdvertiserWrapper';
import { EXPLORE_MORE_BASE_URL, TAB_CONFIG } from './constants';
import { RateTableProductCard } from './RateTableProductCard';
import { type RateTablePanel, RateTableTabs } from './RateTableTabs';

type MarketplaceRateTableProps = StructuredContentDocument<HydratedMarketplaceRateTableProps>;

export function MarketplaceRateTable({ props }: MarketplaceRateTableProps) {
  const { tabs, featuredTabName, showAdvertiserWrapper = false } = props;
  if (tabs.length === 0) return null;

  const featuredIndex = tabs.findIndex(tab => tab.name === featuredTabName);

  const panels: RateTablePanel[] = tabs.map(tab => {
    const { description, linkPath } = TAB_CONFIG[tab.name];
    const isFeatured = tab.name === featuredTabName;

    return {
      name: tab.name,
      content: (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {!isFeatured && (
            <Typography component="p" variant="textSmall">
              {description}
            </Typography>
          )}
          {tab.entities.map((entity, index) => (
            <RateTableProductCard
              key={entity.id}
              entity={entity}
              tabName={tab.name}
              position={index}
            />
          ))}
          <Box sx={{ display: 'flex' }}>
            {/* The theme defaults every Button to fullWidth. */}
            <Button
              variant="tertiary"
              fullWidth={false}
              href={`${EXPLORE_MORE_BASE_URL}${linkPath}`}
              sx={{
                width: 'auto',
                paddingX: 1.5,
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
              }}
            >
              Explore more accounts
            </Button>
          </Box>
        </Box>
      ),
    };
  });

  return (
    <AdvertiserWrapper isEnabled={showAdvertiserWrapper}>
      <RateTableTabs panels={panels} defaultIndex={featuredIndex === -1 ? 0 : featuredIndex} />
    </AdvertiserWrapper>
  );
}
